import { createContext, useContext } from 'react';
import type { DataLabelingProjectModel } from '../services/ProjectService';

export type ProjectLoadStatus = 'loading' | 'ready' | 'error';

// Supplied by MainLayout from freshly loaded project properties, not stale storage.
export const ActiveProjectContext = createContext<{
    project: DataLabelingProjectModel | undefined;
    status: ProjectLoadStatus;
}>({ project: undefined, status: 'loading' });

export const useActiveProject = () => useContext(ActiveProjectContext);
